module.exports = __webpack_public_path__ + "img/816cb7d.png";